import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TeamsService } from '../services/teams-wassali/teams.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private teamService: TeamsService,
    private router: Router) {
  }

  canActivate(): boolean {
    if (this.teamService.isConnected()) {
      return true
    } else {
      this.router.navigate(['/login'])
      return false
    }
  }
  
}
